import React from "react";
import { Progress } from "@/ui/components/ui/progress";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "@/shared/lib/i18n/formatters.ts";

interface LoadingProgressProps {
  isLoading: boolean;
  progress?: number;
}

export const LoadingProgress: React.FC<LoadingProgressProps> = ({ 
  isLoading, 
  progress = 0 
}) => {
  const { t } = useTranslation("machines");

  if (!isLoading) return null;

  return (
    <div className="flex flex-col items-center justify-center h-full space-y-4">
      <div className="flex items-center space-x-2">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
        <span className="text-lg font-medium text-muted-foreground">
          {t("timeline.loadingData")}
        </span>
      </div>
      <div className="w-64 space-y-2">
        <Progress value={progress} className="h-2" />
        <div className="text-center text-sm text-muted-foreground">
          {t("timeline.progress", { value: formatNumber(progress) })}
        </div>
      </div>
    </div>
  );
};
